module.exports = __webpack_public_path__ + "img/card-visa.b1684820.svg";